
<section class="popup-body">
  <div class="popup-content">
    <div class="icon-bg">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none" stroke="#EF4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        aria-hidden="true">
        <path d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7"/>
        <path d="M10 11v6M14 11v6M4 7h16"/>
        <path d="M9 7V4c0-.55228.44772-1 1-1h4c.5523 0 1 .44772 1 1v3"/>
      </svg>
    </div>
    <h3 class="popup-title">Delete {{ sanitizeType(type) || 'page' | lowercase }}?</h3>
    <p class="popup-desc">
      Are you sure you want to delete <strong>{{ sanitizeType(type) || 'page' | lowercase }}</strong>?
      This action cannot be undone.
    </p>
  </div>
  <div class="popup-actions">
    <button class="btn-cancel" (click)="closeDialog(false)">Go Back</button>
    <button class="btn-confirm" (click)="closeDialog(true)">Yes, Delete</button>
  </div>
</section>
